module.exports = __webpack_public_path__ + "static/img/news2_32.e183139.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news2_32.png
// module id = EXGi
// module chunks = 0